<template>
  <div id="app">
      <div id="lockscreen" v-if="$store.state.lockscreen.show">
          <div class="content">
              <div class="header">
                  <i class="fas fa-lock lockscreenlock mb-2"></i><br>
                  <b>Sessie verlopen...</b>
              </div>
              <div class="body">
                <form action="" @submit.prevent="unlockScreen()">
                  <div class="form-group">
                    <input v-model="password" type="password" class="form-control wachtwoord-input mb-3" name="" id="" placeholder="Voer je wachtwoord in...">
                    <input type="submit" class="btn" value="Inloggen">
                  </div>
                </form> 
                <b class="text-danger" v-if="error.show">
                    {{error.message}}
                </b>
              </div>
          </div>
      </div>
     <div @scroll="resetLockscreenTime()"  @mousemove="resetLockscreenTime()"  @click="resetLockscreenTime()" :class="$store.state.lockscreen.show ? 'blur':''">
       <router-view></router-view>     
     </div> 
  </div>
</template>

<script>


export default {
  name: 'app',
  components: {
    
  },
  data(){
    return {
      remainder:0,
      min:30 * 60000,
      lockscreenTime: 30 * 60000,
      password:'',
      error:{show:false,message:''}, 
    }
  },
  methods:{
        resetLockscreenTime:function(){
           
          if(!this.$route.meta.AuthRequired){
            return false;
          }
          setTimeout(()=>{
            this.$store.state.lockscreen.show=true;
          },this.lockscreenTime);
        },
        signin(payload){
          // console.log("I AM LOGGING YOU IN");
            this.$store.dispatch("post",{endpoint:this.$store.state.endpoint+'login',details:payload})
            .then(data=>{
                window.console.log(data);
                // this.login_task.btntext="Redirecting...";

                this.$store.commit('setUser',data.data.user);
                this.$store.commit('setToken',data.data.token);

                location.reload(); 

            })
            .catch(error=>{
              console.log(error.request);
              console.log(error.request);
                if(error.request.status == 401){
                    this.error.show=true;
                    this.error.message="Invalid password. NOW YOU WILL BE LOGGED OUT.";
                    setTimeout(()=>{
                      this.$store.commit('logout');
                    window.location='/login';
                    },1000);

                    return false;
                }

                // window.console.log(JSON.parse(error.request.response));
                this.error.show=true;
                this.error.message="error in connection , please try again"; 
            });
        },
        refreshToken:function(){
            var token=JSON.parse(localStorage.getItem('token'));
            var token_last_set=JSON.parse(localStorage.getItem('token_last_set'));
            this.remainder=Date.now() - token_last_set;

          this.$store.dispatch('get',this.$store.state.endpoint+"refreshtoken?token="+token)
            .then((data)=>{
              console.log(data);
              this.$store.commit('setToken',data.data);
              
               setTimeout(()=>{
                this.refreshToken();
                },(this.min));
                
            })
            .catch(error=>{
              console.log(error);
            }) 
          console.log('token refreshed'); 
        },
        unlockScreen:function(){
            var user=JSON.parse(localStorage.getItem('user'));
            let password=this.password;

            if(password != null){
              this.signin({email:user.email,password});
            }else{
               this.error.show=true;
               this.error.message="Enter your password";
            }
        }
    },
  created(){
    this.resetLockscreenTime();
    var user=JSON.parse(localStorage.getItem('user'));
    var token=JSON.parse(localStorage.getItem('token'));
    var token_last_set=JSON.parse(localStorage.getItem('token_last_set'));

    if(token != null && user !=null){
        this.$store.commit('setUser',user);
        this.$store.commit('setToken',token); 
        
        this.remainder=Date.now() - token_last_set;

        console.log(this.remainder , this.min);
        if(this.remainder < this.min){
          //check session
          this.$store.dispatch('checkAuth')
          .then((resp)=>{
            // window.console.log(resp);
          })
          .catch(error=>{
              // window.console.log(error);
              try{
                
       
                      if(JSON.parse(error.request.response).message == "Token has expired" || JSON.parse(error.request.response).message == "Unauthenticated."){
                          // console.log(JSON.parse(error.request.response).message);
                          //token expired
                          this.$store.commit('logout');
                          // alert("Your session has expired"); 
                            window.location='/';
                      }
                      else if(error.request.status == 401 || error.request.status == 400 || error.request.status == 404){
                          //token expired
 
                          this.$store.state.lockscreen.show=true;
                      
                      }
                  }
                  catch(e){
                    this.$store.commit('logout');
                  }
            
          });
          
        }
        else{
          this.$store.commit('logout');
          // alert("Your session has expired"); 
          window.location='/';
        }

         setTimeout(()=>{
            //refresh token
            this.refreshToken();
          },(this.min-this.remainder));

        
      }
  } 
}
</script>

<style>
  .blur{
    -webkit-filter: blur(5px);
      -moz-filter: blur(5px);
      -o-filter: blur(5px);
      -ms-filter: blur(5px);
      filter: blur(5px);
  }
  #lockscreen{
    position: fixed;
    background: #000000bf;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99999; 
  }
  #lockscreen .content{
    position: absolute; 
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: fit-content;
    height: fit-content;
    color: white;
    text-align: center;
  }
  #lockscreen .header{}
  #lockscreen .header img{
    display: block;
    width: 70px; 
    margin: auto;
  }
  #lockscreen .body{} 
  #lockscreen .body .wachtwoord-input{
    border:1px solid white;
    font-size: 13px;
    padding: 0px 40px;
    text-align: center;
    margin-top: 11px;
    border-radius: 3px;
  }
  .lockscreenlock{
    color: #555;
    font-size: 60px;
  }
</style>
